/* MMG / Kairos Concierge Brand Runtime v4.4.6 - authoritative Stage 4 bootstrap; deterministic sweep and Shopify resource fallback. */
(function(){
'use strict';
if(window.__MMG_KAIROS_SIGNAL_BOOTSTRAP_V446__)return;
window.__MMG_KAIROS_SIGNAL_BOOTSTRAP_V446__=true;

var MASTER='https://cdn.shopify.com/s/files/1/0754/4337/2186/files/kairos-loader-mark-official.svg?v=1790672331';
var LOGO=window.__MMG_KAIROS_AVATAR_PNG__||MASTER;
var WORKER='https://mmg-ios.info-mindsetmediagroup.workers.dev/scripts/kairos-concierge.js?v=kairos-concierge-20260831-8-live-resource-fallback';
var PRESENTATION='https://mmg-ios.info-mindsetmediagroup.workers.dev/scripts/kairos-signal-presentation-stage4-v1.js?v=20260831-stage4-live-resource-v4';
var LAYER='https://mmg-ios.info-mindsetmediagroup.workers.dev/styles/kairos-concierge-panel-layering-v1.css?v=20260831-ios-keyboard-v1';
var SIGNAL_STYLE='https://mmg-ios.info-mindsetmediagroup.workers.dev/styles/kairos-signal-stage3-v1.css?v=20260831-stage3-deterministic-sweep';
var GUIDANCE_STYLE='https://mmg-ios.info-mindsetmediagroup.workers.dev/styles/kairos-guidance-stage4-v1.css?v=20260831-stage4-route-actions-v2';
var PROD_SIGNAL_SHOWN='kairos:signal:shown:v2';
var PROD_SIGNAL_DISMISSED='kairos:signal:dismissed:v2';
var ADAPTER_SIGNAL_SHOWN='kairos:signal:shown:v1';
var ADAPTER_SIGNAL_DISMISSED='kairos:signal:dismissed:v1';
var PREVIEW_QUERY_KEYS=['preview_theme_id','_fd','_sc','pb'];
var GENERIC={
  'Customer Portal':1,'Services':1,'Free Tools':1,'Customer Service':1,
  'Secure Portal':1,'Project Guide':1,'Service Guide':1,
  'Runtime status':1,'Command Center':1,'Support boundary':1
};
var previewResizeObserver=null;
var localResourceRequest=0;

window.__MMG_KAIROS_CONCIERGE_BRAND_V400__=true;
window.__MMG_KAIROS_CONCIERGE_LAUNCHER_ONLY__=true;
window.__MMG_KAIROS_CONCIERGE_BRAND__=Object.assign({},window.__MMG_KAIROS_CONCIERGE_BRAND__||{}, {
  name:'Kairos Concierge',logoUrl:LOGO,iconUrl:LOGO,launcherIconUrl:LOGO,
  logoAlt:'Kairos Concierge',ariaLabel:'Open Kairos Concierge',
  webIdentity:'canonical-k-halo-official-2026-09-28'
});

function storageGet(key){try{return sessionStorage.getItem(key)||'';}catch(_){return'';}}
function storageSet(key,value){try{sessionStorage.setItem(key,String(value));}catch(_){}}
function storageRemove(key){try{sessionStorage.removeItem(key);}catch(_){}}
function styleLink(href,marker){
  var selector='link['+marker+'="true"]';
  var existing=document.querySelector(selector);
  if(existing){if(existing.href!==href)existing.href=href;return;}
  var l=document.createElement('link');l.rel='stylesheet';l.href=href;l.setAttribute(marker,'true');document.head.appendChild(l);
}
function loadScript(src,selector,marker,asyncValue){
  if(document.querySelector(selector))return null;
  var s=document.createElement('script');s.src=src;s.async=!!asyncValue;if(marker)s.setAttribute(marker,'true');document.head.appendChild(s);return s;
}
function cleanTitle(value){
  var s=String(value||'').replace(/\s+/g,' ').trim();
  if(!s)return'';
  s=s.replace(/\s+[-\u2013\u2014]\s+Mindset Media Group(?:\s*\|.*)?$/i,'').trim();
  return s.length>96?s.slice(0,93).trim()+'...':s;
}
function pageTitle(){
  var h=document.querySelector('#MainContent h1,main h1');
  var s=cleanTitle(h&&h.textContent);if(s)return s;
  var og=document.querySelector('meta[property="og:title"]');
  s=cleanTitle(og&&og.getAttribute('content'));if(s)return s;
  return cleanTitle(document.title);
}
function promptLabels(title){
  title=cleanTitle(title);if(!title)return[];
  return['What should I know about '+title+'?','What should I verify first?','What should I do next?','What related resources can help?'];
}
function isGeneric(labels){return labels.length>0&&labels.every(function(x){return GENERIC[String(x||'').trim()]===1;});}
function submit(label){
  var host=document.getElementById('kairos-concierge');if(!host)return;
  var input=host.querySelector('.kc-input'),form=host.querySelector('.kc-compose');if(!input||!form)return;
  input.value=label;input.dispatchEvent(new Event('input',{bubbles:true}));
  if(typeof form.requestSubmit==='function')form.requestSubmit();else form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
}
function localPrompts(){
  var title=pageTitle();if(!title)return;
  document.documentElement.setAttribute('data-mmg-kairos-local-context-ready','true');
  var intelligence=String(document.documentElement.dataset.mmgKairosIntelligenceState||'').trim();
  if(intelligence==='READY'||intelligence==='SESSION_ACTIVE')return;
  var q=document.querySelector('#kairos-concierge .kc-quick');if(!q)return;
  var labels=Array.prototype.map.call(q.querySelectorAll('.kc-chip'),function(b){return String(b.textContent||'').trim();});
  if(!isGeneric(labels))return;
  var f=document.createDocumentFragment();
  promptLabels(title).forEach(function(label){
    var b=document.createElement('button');b.type='button';b.className='kc-chip';b.textContent=label;b.dataset.mmgKairosLocalPrompt='true';
    b.addEventListener('click',function(){submit(label);});f.appendChild(b);
  });
  q.replaceChildren(f);q.dataset.mmgKairosLocalContext='true';
}
function image(host,launcher){
  if(!host)return;
  var img=host.querySelector(':scope > img[data-mmg-kairos-brand-v396="true"]');
  if(!img){
    host.querySelectorAll('img').forEach(function(n){n.remove();});
    img=document.createElement('img');img.dataset.mmgKairosBrandV396='true';host.replaceChildren(img);
  }
  if(img.getAttribute('src')!==LOGO)img.setAttribute('src',LOGO);
  img.alt=launcher?'Kairos Concierge':'';if(!launcher)img.setAttribute('aria-hidden','true');
  img.style.cssText='display:block!important;width:100%!important;height:100%!important;max-width:100%!important;max-height:100%!important;object-fit:contain!important;object-position:center!important;margin:0!important;padding:0!important;border:0!important;border-radius:'+(launcher?'0':'inherit')+'!important;background:transparent!important;box-shadow:none!important;pointer-events:none!important;animation:none!important;';
}
function installMobileQuickPromptFocusGuard(){
  var host=document.getElementById('kairos-concierge');if(!host||host.dataset.mmgKairosChipFocusGuard==='true')return;
  var panel=host.querySelector('.kc-panel'),input=host.querySelector('.kc-input');if(!panel||!input)return;
  host.dataset.mmgKairosChipFocusGuard='true';
  host.addEventListener('click',function(event){
    var width=window.visualViewport&&Number(window.visualViewport.width)>0?Number(window.visualViewport.width):(window.innerWidth||0);if(width>600)return;
    var target=event.target;if(!target||typeof target.closest!=='function')return;
    var chip=target.closest('.kc-chip');if(!chip||!host.contains(chip))return;
    host.setAttribute('data-mmg-kairos-chip-submit','true');
    input.blur();
    var done=false,sawBusy=panel.getAttribute('aria-busy')==='true',idleTimer=null,timeoutTimer=null;
    var observer=new MutationObserver(function(){
      if(panel.getAttribute('aria-busy')==='true'){sawBusy=true;return;}
      if(sawBusy)finish();
    });
    function finish(){
      if(done)return;done=true;observer.disconnect();if(idleTimer)clearTimeout(idleTimer);if(timeoutTimer)clearTimeout(timeoutTimer);
      requestAnimationFrame(function(){input.blur();host.removeAttribute('data-mmg-kairos-chip-submit');syncViewport();});
    }
    observer.observe(panel,{attributes:true,attributeFilter:['aria-busy']});
    setTimeout(function(){if(panel.getAttribute('aria-busy')==='true')sawBusy=true;},0);
    idleTimer=setTimeout(function(){if(!sawBusy)finish();},350);
    timeoutTimer=setTimeout(finish,12000);
  },true);
}
function localRouteTarget(path){
  var target=null,current=null;
  try{target=new URL(String(path||''),location.origin);current=new URL(location.href);}catch(_){return String(path||'');}
  if(target.origin!==current.origin)return'';
  PREVIEW_QUERY_KEYS.forEach(function(key){var value=current.searchParams.get(key);if(value!==null&&value!=='')target.searchParams.set(key,value);});
  return target.pathname+target.search+target.hash;
}
function resourceSearchQuery(label){
  var title=pageTitle().replace(/[\u2122\u00ae\u00a9]/g,' ').replace(/\s+/g,' ').trim();
  if(title)return title.slice(0,120);
  return String(label||'').replace(/[?!.]+/g,' ').replace(/\s+/g,' ').trim().slice(0,120);
}
function normalizeStorefrontResource(resource,type){
  if(!resource||!resource.url)return null;
  var url=null;try{url=new URL(String(resource.url),location.origin);}catch(_){return null;}
  if(url.origin!==location.origin||url.pathname===location.pathname)return null;
  var title=String(resource.title||resource.text||'').replace(/\s+/g,' ').trim();if(!title)return null;
  return{url:url.pathname+url.search+url.hash,title:title,type:type};
}
function predictiveResources(body){
  var results=body&&body.resources&&body.resources.results||{};
  var buckets=[['product',Array.isArray(results.products)?results.products:[]],['page',Array.isArray(results.pages)?results.pages:[]],['article',Array.isArray(results.articles)?results.articles:[]]];
  var out=[],seen={};
  for(var index=0;index<8;index+=1){
    buckets.forEach(function(bucket){
      var item=normalizeStorefrontResource(bucket[1][index],bucket[0]);if(!item||seen[item.url])return;
      seen[item.url]=1;out.push(item);
    });
  }
  return out.slice(0,6);
}
function domResourceFallback(){
  var root=document.querySelector('#MainContent,main')||document;
  var selector='a[href^="/products/"],a[href^="/pages/"],a[href^="/blogs/mindset-journal/"]';
  var out=[],seen={};
  root.querySelectorAll(selector).forEach(function(anchor){
    if(out.length>=6)return;
    var item=normalizeStorefrontResource({url:anchor.getAttribute('href'),title:anchor.textContent},'route');
    if(!item||seen[item.url])return;seen[item.url]=1;out.push(item);
  });
  return out;
}
async function resolveStorefrontResources(label){
  var query=resourceSearchQuery(label);if(!query)return domResourceFallback();
  var endpoint='/search/suggest.json?q='+encodeURIComponent(query)+'&resources[type]='+encodeURIComponent('product,page,article')+'&resources[limit]=8';
  try{
    var response=await fetch(endpoint,{method:'GET',headers:{accept:'application/json'},credentials:'same-origin',cache:'no-store'});
    if(response.ok){var body=await response.json();var resources=predictiveResources(body);if(resources.length)return resources;}
  }catch(_){}
  return domResourceFallback();
}
function waitForLocalPanelIdle(panel){
  return new Promise(function(resolve){
    if(!panel||panel.getAttribute('aria-busy')!=='true'){setTimeout(resolve,120);return;}
    var done=false,timer=null,observer=new MutationObserver(function(){if(panel.getAttribute('aria-busy')==='true')return;finish();});
    function finish(){if(done)return;done=true;observer.disconnect();if(timer)clearTimeout(timer);setTimeout(resolve,80);}
    observer.observe(panel,{attributes:true,attributeFilter:['aria-busy']});timer=setTimeout(finish,5000);
  });
}
function renderStorefrontResourceActions(host,label,resources){
  if(!host||!resources||!resources.length)return;
  var existingAuthoritative=host.querySelector('.mmg-kairos-concierge-route-actions:not([data-mmg-kairos-storefront-fallback="true"])');if(existingAuthoritative)return;
  host.querySelectorAll('.mmg-kairos-concierge-route-actions[data-mmg-kairos-storefront-fallback="true"]').forEach(function(node){node.remove();});
  var log=host.querySelector('.kc-log');if(!log)return;
  var actions=document.createElement('div');actions.className='mmg-kairos-concierge-route-actions';actions.setAttribute('data-mmg-kairos-storefront-fallback','true');actions.setAttribute('aria-label','Kairos related resources');
  resources.slice(0,3).forEach(function(resource){
    var target=localRouteTarget(resource.url);if(!target)return;
    var button=document.createElement('button');button.type='button';button.className='mmg-kairos-concierge-route-action';button.textContent='Open '+resource.title;
    button.addEventListener('click',function(){location.assign(target);});actions.appendChild(button);
  });
  if(!actions.children.length)return;log.appendChild(actions);log.scrollTop=log.scrollHeight;
}
function installStorefrontResourceFallback(){
  var host=document.getElementById('kairos-concierge');if(!host||host.dataset.mmgKairosStorefrontFallback==='true')return;
  var panel=host.querySelector('.kc-panel');if(!panel)return;host.dataset.mmgKairosStorefrontFallback='true';
  host.addEventListener('click',function(event){
    var target=event.target;if(!target||typeof target.closest!=='function')return;
    var chip=target.closest('.kc-chip');if(!chip||!host.contains(chip))return;
    var label=String(chip.textContent||'').trim();if(!label)return;
    var requestId=++localResourceRequest;
    host.querySelectorAll('.mmg-kairos-concierge-route-actions[data-mmg-kairos-storefront-fallback="true"]').forEach(function(node){node.remove();});
    Promise.resolve(resolveStorefrontResources(label)).then(function(resources){
      return waitForLocalPanelIdle(panel).then(function(){
        if(requestId!==localResourceRequest)return;
        setTimeout(function(){if(requestId===localResourceRequest)renderStorefrontResourceActions(host,label,resources);},120);
      });
    }).catch(function(){});
  });
}
function brand(){
  var host=document.getElementById('kairos-concierge');if(!host)return;
  var mark=host.querySelector('.kc-head .kc-mark,.kc-title .kc-mark');
  if(mark){mark.setAttribute('data-mmg-kairos-header-avatar','true');image(mark,false);}
  localPrompts();
  installMobileQuickPromptFocusGuard();
  installStorefrontResourceFallback();
  syncLauncher();
}
function isPreview(){
  var q=String(location.search||'');
  var h=String(location.hostname||'').toLowerCase();
  return !!(window.Shopify&&window.Shopify.designMode)||/(?:^|[?&])preview_theme_id=/.test(q)||/(^|\.)shopifypreview\.com$/.test(h);
}
function syncSignalSessionState(){
  if(isPreview()){
    storageRemove(ADAPTER_SIGNAL_SHOWN);storageRemove(ADAPTER_SIGNAL_DISMISSED);return;
  }
  if(storageGet(PROD_SIGNAL_SHOWN)==='1')storageSet(ADAPTER_SIGNAL_SHOWN,'1');else storageRemove(ADAPTER_SIGNAL_SHOWN);
  if(storageGet(PROD_SIGNAL_DISMISSED)==='1')storageSet(ADAPTER_SIGNAL_DISMISSED,'1');else storageRemove(ADAPTER_SIGNAL_DISMISSED);
}
function installSignalSessionBridge(){
  if(window.__MMG_KAIROS_SIGNAL_SESSION_BRIDGE_V2__)return;
  window.__MMG_KAIROS_SIGNAL_SESSION_BRIDGE_V2__=true;
  window.addEventListener('mmg:kairos-presentation-state',function(event){
    if(isPreview())return;
    var state=String(event&&event.detail&&event.detail.state||'');
    if(state==='SIGNAL'){storageSet(PROD_SIGNAL_SHOWN,'1');return;}
    if(state==='DORMANT')setTimeout(function(){if(storageGet(ADAPTER_SIGNAL_DISMISSED)==='1')storageSet(PROD_SIGNAL_DISMISSED,'1');},0);
  });
}
function syncVisualViewportMetrics(){
  var root=document.documentElement;
  var vv=window.visualViewport;
  var layoutHeight=Math.max(240,window.innerHeight||root.clientHeight||640);
  var height=vv&&Number(vv.height)>0?Number(vv.height):layoutHeight;
  var top=vv&&Number(vv.offsetTop)>=0?Number(vv.offsetTop):0;
  var visualHeight=Math.max(240,Math.round(height));
  root.style.setProperty('--mmg-kairos-visual-height',visualHeight+'px');
  root.style.setProperty('--mmg-kairos-visual-top',Math.max(0,Math.round(top))+'px');
  root.dataset.mmgKairosCompactViewport=(visualHeight<520||visualHeight<Math.round(layoutHeight*0.72))?'true':'false';
}
function previewChromeNodes(){
  var selectors=['#preview-bar-iframe','iframe[src*="preview-bar"]','iframe[src*="preview_bar"]','[data-shopify-preview-bar]','shopify-preview-bar','.shopify-preview-bar'];
  var nodes=[];
  selectors.forEach(function(selector){document.querySelectorAll(selector).forEach(function(node){if(nodes.indexOf(node)===-1)nodes.push(node);});});
  return nodes;
}
function previewClearance(){
  var viewport=window.innerHeight||document.documentElement.clientHeight||0;
  var measured=0;
  previewChromeNodes().forEach(function(node){
    if(!node||typeof node.getBoundingClientRect!=='function')return;
    var rect=node.getBoundingClientRect();
    if(!rect||rect.height<=0||viewport<=0)return;
    if(rect.top<viewport&&rect.bottom>=viewport-4)measured=Math.max(measured,viewport-Math.max(0,rect.top));
  });
  return measured>0?Math.ceil(measured+12):0;
}
function syncPreviewOffset(){
  var root=document.documentElement;
  if(!isPreview()){root.style.setProperty('--mmg-kairos-preview-clearance','0px');return;}
  root.style.setProperty('--mmg-kairos-preview-clearance',previewClearance()+'px');
}
function syncViewport(){syncVisualViewportMetrics();syncPreviewOffset();}
function observePreviewChrome(){
  if(!isPreview()||typeof ResizeObserver!=='function')return;
  if(previewResizeObserver)previewResizeObserver.disconnect();
  previewResizeObserver=new ResizeObserver(syncViewport);
  previewChromeNodes().forEach(function(node){previewResizeObserver.observe(node);});
}
function previewSetup(){
  if(!isPreview()){try{delete window.MMGKairosContextualStagingPreview;}catch(_){window.MMGKairosContextualStagingPreview=false;}return;}
  window.MMGKairosContextualStagingPreview=true;
  storageRemove(ADAPTER_SIGNAL_SHOWN);storageRemove(ADAPTER_SIGNAL_DISMISSED);
  document.documentElement.dataset.mmgKairosShopifyPreview='true';
  if(!document.getElementById('mmg-kairos-signal-preview-offset')){
    var s=document.createElement('style');s.id='mmg-kairos-signal-preview-offset';
    s.textContent='.mmg-kairos-signal-sweep{top:calc(var(--mmg-kairos-visual-top,0px) + 2px)!important;bottom:auto!important;z-index:2147483646!important;height:5px!important;animation-duration:1800ms!important;box-shadow:0 0 12px rgba(41,151,255,.72)!important}.mmg-kairos-guidance{bottom:calc(var(--mmg-kairos-preview-clearance,0px) + 60px)!important}.mmg-kairos-path-marker{bottom:calc(var(--mmg-kairos-preview-clearance,0px) + 10px)!important}';
    document.head.appendChild(s);
  }
  syncViewport();observePreviewChrome();
  [120,360,900,1800].forEach(function(ms){setTimeout(function(){syncViewport();observePreviewChrome();},ms);});
}
function ensureDeterministicSweepStyle(){
  if(document.getElementById('mmg-kairos-deterministic-sweep-style'))return;
  var style=document.createElement('style');style.id='mmg-kairos-deterministic-sweep-style';
  style.textContent='.mmg-kairos-deterministic-sweep[data-mmg-kairos-deterministic-sweep="true"]{position:fixed!important;left:0!important;right:0!important;top:auto!important;bottom:calc(var(--mmg-kairos-preview-clearance,0px) + var(--mmg-kairos-browser-occlusion,0px))!important;height:3px!important;z-index:2147483646!important;pointer-events:none!important;display:block!important;background:linear-gradient(90deg,rgba(41,151,255,0),rgba(41,151,255,.98) 18%,rgba(0,113,227,1) 72%,rgba(122,205,255,.92))!important;transform:scaleX(0);transform-origin:left center!important;opacity:0;will-change:transform,opacity!important;animation:mmg-kairos-static-signal-sweep 1100ms cubic-bezier(.2,.72,.18,1) 1 both!important}@keyframes mmg-kairos-static-signal-sweep{0%{transform:scaleX(0);opacity:0}12%{opacity:1}82%{transform:scaleX(1);opacity:1}92%{transform:scaleX(1);opacity:1}100%{transform:scaleX(1);opacity:0}}@media (prefers-reduced-motion:reduce){.mmg-kairos-deterministic-sweep[data-mmg-kairos-deterministic-sweep="true"]{animation:none!important;transform:scaleX(1)!important;opacity:.86!important;will-change:auto!important}}';
  (document.head||document.documentElement).appendChild(style);
}
function emitDeterministicSweep(){
  var root=document.documentElement;if(root.getAttribute('data-mmg-kairos-page-sweep-v446')==='true')return;
  root.setAttribute('data-mmg-kairos-page-sweep-v446','true');if(!document.body)return;
  ensureDeterministicSweepStyle();
  if(document.querySelector('.mmg-kairos-deterministic-sweep'))return;
  var sweep=document.createElement('div');sweep.className='mmg-kairos-deterministic-sweep';sweep.setAttribute('data-mmg-kairos-deterministic-sweep','true');sweep.setAttribute('aria-hidden','true');document.body.appendChild(sweep);
  var removed=false;function remove(){if(removed)return;removed=true;sweep.remove();}
  sweep.addEventListener('animationend',remove,{once:true});setTimeout(remove,2200);
}
function quietLauncher(launcher){
  if(!launcher)return;
  launcher.setAttribute('aria-label','Open Kairos');launcher.setAttribute('title','Kairos');
  launcher.dataset.mmgKairosQuietEntry='true';
  launcher.removeAttribute('data-mmg-kairos-launcher-v396');
  launcher.style.cssText+='background:#fff!important;background-image:none!important;color:#121212!important;border:1px solid rgba(18,18,18,.1)!important;box-shadow:0 3px 12px rgba(18,18,18,.12)!important;display:flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;width:46px!important;height:46px!important;min-width:46px!important;min-height:46px!important;max-width:46px!important;max-height:46px!important;aspect-ratio:1 / 1!important;border-radius:50%!important;padding:0!important;line-height:1!important;text-indent:0!important;box-sizing:border-box!important;';
  var label=launcher.querySelector('[data-mmg-kairos-quiet-label="true"]');
  if(!label){
    label=document.createElement('span');label.dataset.mmgKairosQuietLabel='true';label.textContent='KAIROS';
    label.style.cssText='display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;height:100%!important;margin:0!important;padding:0!important;line-height:1!important;color:#121212!important;font-size:9px!important;letter-spacing:.18em!important;text-indent:.18em!important;transform:translateY(-.5px)!important;white-space:nowrap!important;pointer-events:none!important;box-sizing:border-box!important;';
    launcher.replaceChildren(label);
  }
}
function syncLauncher(){
  var host=document.getElementById('kairos-concierge');if(!host)return;
  var state=String(document.documentElement.dataset.mmgKairosPresentationState||'DORMANT');
  var launcher=host.querySelector(':scope > .kc-launcher');
  if(!launcher)return;
  if(state==='DORMANT'||state==='SIGNAL')quietLauncher(launcher);
}
function routeHandle(match){
  if(!match)return'';
  var handle='';try{handle=decodeURIComponent(match[1]||'').trim();}catch(_){handle=String(match[1]||'').trim();}
  return handle;
}
function currentResourceSignal(){
  var path=String(location.pathname||'');var match=null;var handle='';
  match=path.match(/^\/products\/([^/?#]+)/i);handle=routeHandle(match);if(handle)return{type:'PRODUCT_VIEW',resourceId:'product:'+handle};
  match=path.match(/^\/blogs\/mindset-journal\/([^/?#]+)/i);handle=routeHandle(match);if(handle)return{type:'JOURNAL_VIEW',resourceId:'journal:'+handle};
  match=path.match(/^\/pages\/([^/?#]+)/i);handle=routeHandle(match);if(handle)return{type:'GOVERNED_PAGE_VIEW',resourceId:'page:'+handle};
  return null;
}
function contextGate(){
  var ready=window.MMGKairosSessionInitialContextReady;
  if(ready&&typeof ready.then==='function')return Promise.race([Promise.resolve(ready).catch(function(){}),new Promise(function(ok){setTimeout(ok,2200);})]);
  var signal=currentResourceSignal();if(!signal)return Promise.resolve();
  var prefix=String(signal.resourceId||'resource').split(':')[0]||'resource';
  var randomId=window.crypto&&typeof window.crypto.randomUUID==='function'?window.crypto.randomUUID():prefix+'-'+Date.now();
  var body={batchId:randomId,occurredAt:new Date().toISOString(),signals:[signal]};
  var task=Promise.race([
    fetch('https://kairos.themindsetmediagroup.com/api/kairos/session-intelligence/signals',{method:'POST',headers:{'content-type':'application/json'},credentials:'include',body:JSON.stringify(body)}).catch(function(){}),
    new Promise(function(ok){setTimeout(ok,2200);})
  ]);
  window.MMGKairosSessionInitialContextReady=task;return task;
}
function presentation(){loadScript(PRESENTATION,'script[src*="/scripts/kairos-signal-presentation-stage4-v1.js"]','data-mmg-kairos-signal-stage4',true);}
function worker(){
  if(document.querySelector('script[src*="/scripts/kairos-concierge.js"]')){brand();presentation();return;}
  var s=document.createElement('script');s.src=WORKER;s.async=false;s.dataset.mmgKairosConciergeV446='true';
  s.addEventListener('load',function(){brand();presentation();[80,220,600,1400].forEach(function(ms){setTimeout(brand,ms);});});
  s.addEventListener('error',presentation,{once:true});document.head.appendChild(s);
}
function mount(){
  syncVisualViewportMetrics();
  syncSignalSessionState();installSignalSessionBridge();
  previewSetup();
  styleLink(LAYER,'data-mmg-kairos-panel-layering-v1');
  styleLink(SIGNAL_STYLE,'data-mmg-kairos-signal-stage3');
  styleLink(GUIDANCE_STYLE,'data-mmg-kairos-guidance-stage4');
  ensureDeterministicSweepStyle();
  setTimeout(emitDeterministicSweep,520);
  contextGate().then(worker,worker);
}
var mo=new MutationObserver(function(){brand();});
mo.observe(document.documentElement,{attributes:true,attributeFilter:['data-mmg-kairos-presentation-state','data-mmg-kairos-intelligence-state']});
window.addEventListener('pageshow',function(event){syncViewport();syncSignalSessionState();previewSetup();brand();if(event&&event.persisted){document.documentElement.removeAttribute('data-mmg-kairos-page-sweep-v446');setTimeout(emitDeterministicSweep,180);}},{passive:true});
window.addEventListener('resize',syncViewport,{passive:true});
window.addEventListener('orientationchange',syncViewport,{passive:true});
if(window.visualViewport){window.visualViewport.addEventListener('resize',syncViewport,{passive:true});window.visualViewport.addEventListener('scroll',syncViewport,{passive:true});}
window.addEventListener('mmg:kairos-session:shadow-context',brand);
document.addEventListener('shopify:section:load',function(){syncViewport();syncSignalSessionState();previewSetup();brand();});
if(location.pathname==='/'||location.pathname===''){if(document.readyState==='complete')mount();else window.addEventListener('load',mount,{once:true});}else if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
})();
